(function(){
    // var storyListTemplate =
    //     '{{#if contentType == "02"}}'+
    //     '<li class="lists">' +
    //     '   <div class="list-inner">' +
    //     '       <a href="/gram/story-detail?storyId={{storyId}}">' +
    //     '           <span class="thumb">' +
    //     '               <img src="{{listThumbnailPath}}" alt="">' +
    //     '               <span class="tag">{{categoryTypeName}}</span>' +
    //     '           </span>' +
    //     '           <div class="info">' +
    //     '               <span class="title"><i class="blind">스토리 제목</i>{{title}}</span>' +
    //     '           </div>' +
    //     '       </a>' +
    //     '   </div>' +
    //     '</li>' +
    //     '{{#else}}'+
    //     '<li class="lists youtube-box">' +
    //     '   <div class="list-inner">' +
    //     '       <a href="#" data-src="{{videoUrl}}{{#if videoType=="01"}}?autoplay=autoplay{{#else}}?autoplay=1&mute=1{{/if}}"' +
    //     '                   data-type="{{#if videoType=="01"}}mp4{{#else}}youtube{{/if}}" data-target="modal" class="see-video">' +
    //     '           <span class="thumb">' +
    //     '               <img src="{{listThumbnailPath}}" alt="영상">' +
    //     '               <span class="tag">{{categoryTypeName}}</span>' +
    //     '           </span>' +
    //     '           <div class="info">' +
    //     '               <span class="title"><i class="blind">스토리 제목</i>{{title}}</span>' +
    //     '           </div>' +
    //     '       </a>' +
    //     '   </div>' +
    //     '</li>' +
    //     '{{/if}}';

    var storyListTemplate =
        '{{#if contentType == "02"}}'+
        '<li class="lists">' +
        '   <div class="list-inner">' +
        '       <a href="" data-url="/gram/story-detail?storyId={{storyId}}" data-contents="{{title}}">' + /* 2022.07.29 GA 추가 */
        '           <span class="thumb">' +
        '               <img src="{{listThumbnailPath}}" alt="">' +
        '               <span class="tag">{{categoryTypeName}}</span>' +
        '           </span>' +
        '           <div class="info">' +
        '               <span class="title"><i class="blind">스토리 제목</i>{{title}}</span>' +
        '           </div>' +
        '       </a>' +
        '   </div>' +
        '</li>' +
        '{{#else}}'+
        '<li class="lists">' +
        '   <div class="list-inner">' +
        '       <a href="#videoPopup" data-src="{{videoUrl}}" data-video-Type="{{videoType}}" data-control="modal" data-contents="{{title}}">' + /* 2022.07.29 GA 추가 */
        '           <span class="thumb">' +
        '               <img src="{{listThumbnailPath}}" alt="영상">' +
        '               <span class="tag">{{categoryTypeName}}</span>' +
        '           </span>' +
        '           <div class="info">' +
        '               <span class="title"><i class="blind">스토리 제목</i>{{title}}</span>' +
        '           </div>' +
        '       </a>' +
        '   </div>' +
        '</li>' +
        '{{/if}}';

    var modalTemplate =
        '<article id="videoPopup" class="popup-wrap gram-video-wrap">' +
        '   <section class="modal-video-asset">' +
        '       <div class="video-asset {{#if videoType === "02"}} youtube {{/if}}">' +
        '{{#if videoType == "02"}}' +
        '           <iframe id="videoPlayerCode" frameborder="0"  webkitallowfullscreen="1" mozallowfullscreen="1" allowfullscreen="1" allow="accelerometer;encrypted-media; gyroscope; picture-in-picture" sandbox="allow-scripts allow-same-origin allow-presentation" title="YouTube video player" width="640" height="360" src="{{videoUrl}}"></iframe>' +
        '{{#else}}' +
        '           <video autoplay muted loop playsInline controls>' +
        '               <source src="{{videoUrl}}" type="video/mp4">' +
        '           </video>' +
        '{{/if}}' +
        '       </div>' +
        '   </section>' +
        '   <button type="button" class="btn-close ui_modal_close"><span class="blind">닫기</span></button>' +
        '</article>';


    var categoryTagTemplate =
        '{{#each item in categoryTypeCodeList}}' +
        '   <li><a href="#" data-code="{{item.commonCodeId}}">{{item.commonCodeName}}</a></li>' +
        '{{/each}}';

    var story = {
        variable: {
            categoryTypeCodeList: null
        },
        el: {
            $contents: null
        },
        selector: {
            tagListWrap: '.tag-list',
            tagList: '.tag-list>li',
            tagListAnchor: '.tag-list>li>a',
            listWrap: '.box-list-inner',
            listAnchor: '.box-list-inner>.lists a',
            btnMore: '#btnMore',
            videoLayer: '#videoPopup',
            closeModal: 'button.btn-close.ui_modal_close'
        },
        init: function(el) {
            this.el.$contents = $(el);
            this.setProperty();
            this.loadStoryList();
            this.bindEvents();
        },
        setProperty: function() {
            var $contents = this.el.$contents;
            $contents.data('categoryType', '');
            $contents.data('page', 1);
        },
        bindEvents: function() {
            var _self = this;
            _self.el.$contents.on('click', _self.selector.btnMore, function(e) {
                e.preventDefault();
                _self.el.$contents.data('page', parseInt(_self.el.$contents.data('page')) + 1);
                _self.loadStoryList();
            }).on('click', _self.selector.tagListAnchor, function(e) {
                e.preventDefault();
                $(this).closest('ul').children().removeClass('on');
                $(this).closest('li').addClass('on');

                var categoryType = $(this).data('code');
                if (!categoryType) categoryType = '';
                _self.el.$contents.data('categoryType', categoryType);
                _self.el.$contents.data('page', 1);
                _self.loadStoryList();
            }).on('click', this.selector.listAnchor, function(e) {
                e.preventDefault();
                if ($(this).attr('href') !== '#videoPopup') {
                    location.href = $(this).data('url');
                } else {
                    var videoUrl = $(this).data('src');
                    var videoType = $(this).data('video-type');
                    //if (videoType == '02') videoUrl += '?autoplay=1&mute=1';
                    var $videoLayer = $(vcui.template(modalTemplate, {videoUrl: videoUrl, videoType: videoType}));
                    _self.el.$contents.find(_self.selector.videoLayer).remove();
                    _self.el.$contents.append($videoLayer.get(0));
                    story.setModalCloseEvt();
                }
            });
        },
        handler: {},
        setCategoryTypeCodeList: function() {
            $(document).find('.tag-list').append(vcui.template(categoryTagTemplate, { categoryTypeCodeList: this.variable.categoryTypeCodeList }));
        },
        setTotalCount: function(listTotalCount) {
            $('#totalCount').html('총 <em>' + listTotalCount + '</em>개');
        },
        setModalCloseEvt: function() {
            $(".ui_modal_close").on("click", function() {
                if ($("video").get(0)) {
                    $("video").get(0).pause();
                }
            });
        },
        loadStoryList: function() {
            var url = this.el.$contents.data("story-list");
            var params = {
                categoryType: this.el.$contents.data('categoryType'),
                page: this.el.$contents.data('page')
            };

            lgkorUI.showLoading();
            lgkorUI.requestAjaxDataPost(
                url,
                params,
                function (result) {
                    if (result.status == 'fail') {
                        lgkorUI.alert('', {
                            title: result.message
                        });
                    } else {
                        // 카테고리 태그
                        if (!this.variable.categoryTypeCodeList) {
                            this.variable.categoryTypeCodeList = result.data[0].categoryTypeCodeList;
                            this.setCategoryTypeCodeList();
                        }

                        // 스토리
                        if(result.data[0].gramStoryList && result.data[0].gramStoryList.length > 0) {
                            var page = parseInt(result.data[0].pagination.page);
                            var totalcnt = parseInt(result.data[0].pagination.totalCount);

                            if(page == 1) {
                                this.el.$contents.find(this.selector.listWrap).empty();
                            }

                            for(var idx in result.data[0].gramStoryList){
                                var list = vcui.template(storyListTemplate, result.data[0].gramStoryList[idx]);
                                this.el.$contents.find(this.selector.listWrap).append(list);
                            }

                            // 더보기 활성화
                            if(page == totalcnt) $(this.selector.btnMore).closest('.btn-area').css('display','none');
                            else $(this.selector.btnMore).closest('.btn-area').css('display','block');

                            // 총 갯수
                            this.setTotalCount(result.data[0].listTotalCount);

                        } else {
                            this.el.$contents.find(this.selector.listWrap).empty();
                            this.setTotalCount(0);
                        }
                    }

                    lgkorUI.hideLoading();
                }.bind(this),
                true
            );
        }
    };
    $(window).ready(function() {
        story.init('.contents.gram-cont');
    });
})();